import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../main/components/BaseButton";
import { useContext } from "react";
import { MainContext } from "../../main/context/MainContextProvider";

export default function ErrorMessage() {
  const { setUser } = useContext(MainContext);
  const navigate = useNavigate();

  const isPasswordRecovery =
    window.location.pathname.includes("/recuperar-senha");
  const isFirstAccess = window.location.pathname.includes("/nova-senha");

  const handleButtonBack = () => {
    setUser(undefined);
    navigate("/login");
  };
  const handleButtonTryAgain = () => {
    isPasswordRecovery && navigate("/login/recuperar-senha");
    isFirstAccess && navigate("/login/nova-senha");
  };

  return (
    <Grid
      container
      spacing={2}
      rowGap={2}
      justifyContent="center"
      maxWidth={"600px"}
    >
      <Grid
        item
        xs={10}
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
        container
        direction="column"
      >
        <Typography variant="h4" color="#D1382E">
          Oops!
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <Typography>
          {isPasswordRecovery &&
            "Não encontramos usuário para o e-mail enviado. Deseja tentar novamente?"}
          {isFirstAccess &&
            "Ocorreu um erro desconhecido, tente novamente ou volte para login."}
        </Typography>
      </Grid>
      <Grid xs={10} md={5} item justifyContent="center">
        <BaseButton
          type="button"
          onClick={() => handleButtonBack()}
          title="Voltar para tela de login"
        />
      </Grid>
      <Grid xs={10} md={5} item justifyContent="center">
        <BaseButton
          type="button"
          onClick={() => handleButtonTryAgain()}
          title="Tentar novamente"
        />
      </Grid>
    </Grid>
  );
}
